import { __decorate, __metadata } from "tslib";
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator';
import { COSMIC_APPLICATION } from '~/application.config';
import { DocumentType } from '~/db_types';
import BaseVue from '~/nasa_ui/base/BaseVue';
import CurrentUserMixin from '~/nasa_ui/mixins/CurrentUserMixin';
import { EsocApplication, EsocApplicationDisplay, UserPermission } from '~/nasa_ui/types';
import { getAssetLogoPath } from '~/nasa_ui/utils/helpers/assets';
import { CosmicIcons } from '~/nasa_ui/utils/ui/CosmicIcons';
import { getCdocsUrl, getKnowledgeBaseUrl, getOgUrl } from '~/nasa_ui/utils/url';
let TheSideNav = class TheSideNav extends Mixins(BaseVue, CurrentUserMixin) {
    COSMIC_APPLICATION = COSMIC_APPLICATION;
    CosmicIcons = CosmicIcons;
    DocumentType = DocumentType;
    EsocApplicationDisplay = EsocApplicationDisplay;
    UserPermission = UserPermission;
    applicationVersion;
    get computedNavbarIcon() {
        const count = localStorage.getItem('count_for_nothing_important');
        if (count && parseInt(count) > 1000) {
            localStorage.setItem('count_for_nothing_important', '0');
            return 'fa-duotone fa-solid fa-burger';
        }
        return 'fa-duotone fa-solid fa-bars';
    }
    get cosmicOgLogoSrc() {
        return getAssetLogoPath('cosmic_og_logo_light.svg');
    }
    get cosmicOgRoute() {
        return getOgUrl(`/?ctx=${this.currentUserActiveSupportContext}`);
    }
    get cosmicDocumentsLogoSrc() {
        return getAssetLogoPath(`cosmic_documents_app_logo_light.svg`);
    }
    get cosmicDocumentsRoute() {
        return getCdocsUrl(`/?ctx=${this.currentUserActiveSupportContext}`);
    }
    get cosmicKnowledgeBaseRoute() {
        return getKnowledgeBaseUrl();
    }
    get cosmicKnowledgeBaseLogoSrc() {
        return getAssetLogoPath('cosmic_knowledge_base_light.svg');
    }
    get cosmicSupportRoute() {
        return `/cosmic_support?ctx=${this.currentUserActiveSupportContext}`;
    }
    get cosmicSupportLogoSrc() {
        return getAssetLogoPath('cosmic_support_light.svg');
    }
    get isApplicationCdocs() {
        return COSMIC_APPLICATION === EsocApplication.CDOCS;
    }
    get isApplicationOg() {
        return COSMIC_APPLICATION === EsocApplication.OG;
    }
    get shouldShowManageUsers() {
        return this.currentUserHasPermission(UserPermission.USER_ADMIN);
    }
    get shouldShowManageUserGroups() {
        return this.currentUserHasPermission(UserPermission.USER_GROUPS_ADMIN);
    }
    onClickOfShowChangeLog() { }
};
__decorate([
    Prop({
        required: true,
        type: String
    }),
    __metadata("design:type", String)
], TheSideNav.prototype, "applicationVersion", void 0);
__decorate([
    Emit('show_application_change_log'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TheSideNav.prototype, "onClickOfShowChangeLog", null);
TheSideNav = __decorate([
    Component
], TheSideNav);
export default TheSideNav;
